import React from 'react';

const IconLogo = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 84 96">
    <title>Logo</title>
    <g id="Logo" transform="translate(-10.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <polygon
          fill="none"
          stroke="#64FFDA"
          strokeWidth="6"
          points="39,0 0,22 0,67 39,90 78,68 78,23"
        />
      </g>
    </g>
    <g>
      <path fill="#64FFDA" d="M31.9,32.7H38v25.6h14.1v5.1H31.9V32.7z" />
    </g>
  </svg>
);

export default IconLogo;
